<template>
    <div class="row">
        <div class="col-12">
            <h2 class="m-0 h1 text-uppercase">Seleccionar sector</h2>
        </div>
        <div class="col-12">
            <div class="svg-container mb-4 mb-lg-5">
                <transition name="fade" mode="out-in" v-if="!loading">
                    <div class="row" v-if="zonas" key="zonas" id="zonas">
                        <div class="col-lg-8">
                            <h3 class="subtitle h4 light mb-3 mb-lg-4">A) Selecciona el sector pinchando en el mapa:</h3>
                            <div class="lightgray-content mb-3 mb-lg-4">
                                <div>
                                    <template v-if="abono_seleccionado.place.svg_teatros">
                                        <SvgComponent 
                                            :zonas="zonas_formatted" 
                                            :place="abono_seleccionado.place" 
                                            @clickZona="terminar"
                                        ></SvgComponent>
                                    </template>
                                    <template v-else>
                                        <MapaSvgComponent
                                            :zonas="zonas_formatted"
                                            :can_click="true"
                                            :popup_enabled="true"
                                            :occupied="false"
                                            @clickZona="terminar"
                                            :place="abono_seleccionado.place"
                                        ></MapaSvgComponent>
                                    </template>     
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-4">
                            <h3 class="subtitle h4 light mb-3 mb-lg-4 ">B) O en la siguiente tabla:</h3>
                            <div class="lightgray-content p-2 pb-0">
                                <TablaSectoresComponent :zonas="zonas_formatted" @clickZona="terminar"></TablaSectoresComponent>
                            </div>
                        </div>
                    </div>
                </transition>
                <template v-else>
                    <LoaderComponent></LoaderComponent>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import SvgComponent from '@/components/svg/SvgComponent';
    import MapaSvgComponent from '@/components/frontend/abonos/nuevo/MapaSvgComponent';
    import TablaSectoresComponent from '@/components/frontend/abonos/nuevo/TablaSectoresComponent';

    export default {
        props: ['zonas', 'abono_seleccionado'],
        data() {
            return {
                loading: false
            }
        },
        computed: {
            zonas_formatted() {
                var zonas = [];
                for (var i in this.zonas) {
                    var disponible = false;
                    for (var j in this.zonas[i].tipos_abonos) {
                        if(this.zonas[i].tipos_abonos[j].id == this.abono_seleccionado.id) {
                            disponible = true;
                        }

                        var zona = this.zonas[i];

                        if(!disponible && zona.esta_disponible) {
                            zona.esta_disponible = false;
                        }

                        zonas.push(zona);
                    }
                }

                return zonas;
            },
        },
        methods: {
            terminar(zona) {
                this.$emit('terminado', zona);
            }
        },
        components: {
            SvgComponent, MapaSvgComponent, TablaSectoresComponent
        }
    }
</script>
